export default __webpack_public_path__ + "a2599587e45757b4acde35253f043e1a.jpg";